module.exports = __webpack_public_path__ + "assets/compcar.41eba03c.svg";